import { useState } from 'react';

export default function Gallery() {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const images = [
    {
      url: 'https://readdy.ai/api/search-image?query=modern%20white%20wall%20mounted%20air%20conditioner%20unit%20in%20contemporary%20bedroom%20interior%20elegant%20design%20sleek%20minimalist%20style%20high%20quality%20residential%20cooling%20system%20clean%20installation&width=600&height=800&seq=gallery-wall-001&orientation=portrait',
      title: 'Climatizzatore a Parete Moderno'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=dual%20split%20air%20conditioning%20units%20installed%20in%20bright%20modern%20living%20room%20white%20interior%20contemporary%20home%20cooling%20system%20professional%20installation%20clean%20design&width=600&height=600&seq=gallery-split-001&orientation=squarish',
      title: 'Split Unit Dual in Soggiorno'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=professional%20technician%20in%20blue%20uniform%20installing%20air%20conditioner%20on%20wall%20using%20tools%20ladder%20equipment%20detailed%20installation%20work%20residential%20service%20high%20quality&width=600&height=800&seq=gallery-install-001&orientation=portrait',
      title: 'Tecnico Durante Installazione'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=multiple%20outdoor%20air%20conditioning%20compressor%20units%20mounted%20on%20building%20exterior%20wall%20modern%20multi%20split%20system%20professional%20installation%20urban%20residential%20setting&width=600&height=600&seq=gallery-outdoor-001&orientation=squarish',
      title: 'Sistema Multi-Split Esterno'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=elegant%20designer%20air%20conditioner%20unit%20in%20modern%20bedroom%20interior%20white%20minimalist%20decor%20stylish%20cooling%20system%20premium%20residential%20installation%20sophisticated%20design&width=600&height=800&seq=gallery-bedroom-001&orientation=portrait',
      title: 'Climatizzatore Design in Camera'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=white%20outdoor%20air%20conditioning%20compressor%20unit%20mounted%20on%20building%20facade%20clean%20professional%20installation%20modern%20residential%20cooling%20system%20exterior%20view&width=600&height=600&seq=gallery-facade-001&orientation=squarish',
      title: 'Unità Esterna su Facciata'
    }
  ];

  return (
    <section id="gallery" className="py-24 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block bg-[#E6F4FF] text-[#1A2B4A] px-5 py-2 rounded-full text-sm font-semibold mb-4">
            GALLERIA PROGETTI
          </div>
          <h2 className="text-[#1A2B4A] font-bold text-5xl">
            I Nostri Lavori
          </h2>
        </div>

        {/* Masonry Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {images.map((image, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-3xl cursor-pointer"
              style={{ 
                height: index % 3 === 0 ? '500px' : '350px'
              }}
              onClick={() => setSelectedImage(image.url)}
            >
              <img
                src={image.url}
                alt={image.title}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-[#1A2B4A]/0 group-hover:bg-[#1A2B4A]/70 transition-all duration-300 flex items-center justify-center">
                <div className="text-white text-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 px-6">
                  <i className="ri-eye-line text-4xl mb-3"></i>
                  <p className="font-semibold text-lg">{image.title}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-6"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-6 right-6 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white text-2xl transition-colors cursor-pointer whitespace-nowrap"
            onClick={() => setSelectedImage(null)}
          >
            <i className="ri-close-line"></i>
          </button>
          <img
            src={selectedImage}
            alt="Gallery"
            className="max-w-full max-h-full object-contain rounded-2xl"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
}